var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M0 20L20 0l20 20-3.626 3.51L22.456 9.59V40h-4.912V9.59L3.51 23.51","fill-rule":"evenodd"}})}
var staticRenderFns = []

export { render, staticRenderFns }